import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialogRef, MatDialog } from '@angular/material/dialog';
import { AlertDialogComponent } from 'src/app/components/alert-dialog/alert-dialog.component';
import { CompanyService, ContactService } from 'src/app/services';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-contact-list-dialog',
  templateUrl: './contact-list-dialog.component.html',
  styleUrls: ['./contact-list-dialog.component.scss']
})
export class ContactListDialogComponent implements OnInit, OnDestroy
{
  close: Boolean;
  areContactsEditable: boolean;
  private webSettingsSubscription: Subscription;

  constructor(
    private contactService: ContactService,
    private companyService: CompanyService,
    public dialogRef: MatDialogRef<ContactListDialogComponent>,
    public dialog: MatDialog,

  ) { }

  ngOnInit(): void
  {
    this.checkEmailsInitially();
    this.webSettingsSubscription = this.companyService.webSettings.subscribe(w =>
    {
      if (w)
      {
        this.areContactsEditable = w.AreContactsEditable ?? true;
      }
    });
  }

  checkEmailsInitially(): void
  {
    this.close = false;

    if (!this.contactService.checkEmails())
    {
      this.dialogRef.close();
    }
    return

  }

  checkEmails(): void
  {
    //if true no emails 
    if (!this.contactService.checkEmails())
    {
      this.dialogRef.close();
    } 
    else
    {
      let message: string;

      if (!this.areContactsEditable)
      {
        message = "Please add a new contact with an email address to continue."
      }
      else
      {
        message = "Please add an email address to an existing contact or add a new contact with an email address to continue."
      }

      this.dialog.open(AlertDialogComponent, {
        panelClass: "form-field-less-than-180",
        width: "500px",
        height: "200px",
        data: {
          title: "Email is required",
          message: message,
          buttonText: "Close",
        },
      });
    }
  }

  ngOnDestroy(): void
  {
    this.webSettingsSubscription.unsubscribe();
  }

}
